export const topArrow = function (aColor, aWidth, aHeight) {
  if (aWidth === void 0) {
    aWidth = '4px';
  }
  if (aHeight === void 0) {
    aHeight = '4px';
  }
  return `
    border-bottom: ${aWidth} solid ${aColor};
    border-left: ${aHeight} solid transparent;
    border-right: ${aHeight} solid transparent;
    border-top: none;
  `;
};
export const rightArrow = function (aColor, aWidth, aHeight) {
  if (aWidth === void 0) {
    aWidth = '4px';
  }
  if (aHeight === void 0) {
    aHeight = '4px';
  }
  return `
    border-bottom: ${aWidth} solid transparent;
    border-left: ${aHeight} solid ${aColor};
    border-right: none;
    border-top: ${aWidth} solid transparent;
  `;
};
export const bottomArrow = function (aColor, aWidth, aHeight) {
  if (aWidth === void 0) {
    aWidth = '4px';
  }
  if (aHeight === void 0) {
    aHeight = '4px';
  }
  return `
    border-bottom: none;
    border-left: ${aHeight} solid transparent;
    border-right: ${aHeight} solid transparent;
    border-top: ${aWidth} solid ${aColor};
  `;
};
export const leftArrow = function (aColor, aWidth, aHeight) {
  if (aWidth === void 0) {
    aWidth = '4px';
  }
  if (aHeight === void 0) {
    aHeight = '4px';
  }
  return `
    border-bottom: ${aWidth} solid transparent;
    border-left: none;
    border-right: ${aHeight} solid ${aColor};
    border-top: ${aWidth} solid transparent;
  `;
};